<template>
  <div class="popup_in flex flex--column">
    <div class="pop-confirm popup">
      <div class="ic-ok"><okSvg /></div>
      <div class="title">
        התור עודכן בהצלחה
        <!-- <br />
        נשלח SMS עדכון למטופל -->
      </div>
      <!-- <div class="title--32 ft--300">
        באפשרותך להוסיף תור נוסף לאותו מטופל עם הפרטים הקיימים
      </div> -->
      <!-- <div class="pop-confirm-btns flex flex--content--center">
        <a class="link_blue" @click.prevent="addNewApp">קביעת תור נוסף</a> -->
      <a class="bt_blue" @click.prevent="goHome">סגור</a>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import okSvg from "../../assets/img/svg/ok.svg";
import { mapMutations, mapGetters } from "vuex";
import { getHash } from "../../utilities/hash.js";

export default {
  name: "ConfirmEditApp",
  components: {
    okSvg
  },
  computed: {
    ...mapGetters(["appTimeEdit"])
  },
  methods: {
    ...mapMutations(["SET_IS_CHANGE_APP", "SET_APP_TIME_EDIT"]),
    async goHome() {
      const date = this.$moment(this.appTimeEdit.date, "DD/MM/YYYY").format(
        "MM/DD/YYYY"
      );
      await this.SET_IS_CHANGE_APP(true);
      await this.SET_APP_TIME_EDIT(null);
      const hash = getHash({
        date: this.$moment(date, "MM/DD/YYYY").format("YYYY-MM-DD"),
        view: "day"
      });
      this.$router.push("/dashboard#" + hash);
      this.$emit("close");
    }
  }
};
</script>
